import { getPlatformForApi } from "../../config/platform-config";
import { getAppVersion } from "./getAppVersion";

export const createMetaHeaders = () => {
  return {
    "X-Anydo-Version": getAppVersion(),
    "X-Anydo-Platform": getPlatformForApi(),
  };
};
